window.APP_URL = "https://staging.bookingaggregator.com";